import Box from '@mui/material/Box';
import Fade from '@mui/material/Fade';
import Typography from '@mui/material/Typography';
import React from 'react';
import { ConfirmedGraphic } from '../../../../design-system';

export const CodeVerified = () => (
  <Fade in>
    <div>
      <ConfirmedGraphic textAlign="center" svgProps={{ style: { maxWidth: '60%', height: '100%' } }} />
      <div>
        <Box mt={3} textAlign="center">
          <Typography>Thanks for verifying your email address.</Typography>
        </Box>
        <Box mt={2} textAlign="center">
          <Typography>Go to the Evnex app to sign in</Typography>
        </Box>
      </div>
    </div>
  </Fade>
);
